import React, { FC, useEffect, useState } from "react";
import { LEVELS } from "@package/map";
import { ReactSortable } from "react-sortablejs";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { changeLayer } from "Redux/layerControlSlice";
import { Button, Card, Typography, Grid, Box } from "@mui/material";
import MenuButton from "./Button";

const draggableList = [
  {
    id: 1,
    name: "زون ها",
  },
  {
    id: 2,
    name: "ایستگاه ها",
  },
  {
    id: 3,
    name: "مسیر ها",
  },
  {
    id: 4,
    name: "تقاضای سفر",
  },
];

interface ItemType {
  id: number;
  name: string;
}

export default function LayerControl() {
  const dispatch = useAppDispatch();
  const [list, setList] = useState<ItemType[]>(draggableList);
  const { zoneLayer, stationLayer, pathLayer, survayLayer } = useAppSelector((state) => state.layers);

  useEffect(() => {
    const myState = { zoneLayer, stationLayer, pathLayer, survayLayer };
    for (let i = 0; i < list.length; i += 1) {
      switch (list[i]?.id) {
        case 1:
          myState.zoneLayer = 14 - i;
          break;
        case 2:
          myState.stationLayer = 14 - i;
          break;
        case 3:
          myState.pathLayer = 14 - i;
          break;
        case 4:
          myState.survayLayer = 14 - i;
          break;
        default:
          break;
      }
    }
    dispatch(changeLayer(myState));
  }, [list]);

  return (
    <Card sx={{ p: 1.5 }}>
      <div className="App">
        <ReactSortable
          filter=".addImageButtonContainer"
          dragClass="sortableDrag"
          list={list}
          setList={setList}
          animation={200}
          easing="ease-out"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {list.map((item, index) => (
            // <div className="draggableItem">{item.name}</div>
            <Grid
              container
              mb={1}
              alignItems="center"
              columnSpacing={0.5}
              sx={{ width: "15vw", cursor: "pointer", padding: "0" }}
            >
              <Grid item xs={1.5}>
                <Typography align="center" className="fa-number">
                  {list.length - index}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Box sx={{ border: "1px solid #aaa", p: 1.5, borderRadius: 1 }}>
                  <Typography color="common.black" fontWeight="600">
                    {item.name}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ))}
        </ReactSortable>
      </div>
    </Card>
  );
}
